export const MaxLengths = {
    actualite: {
        description: 1000,
        titre: 100,
    },
    api: {
        categorie: 50,
        description: 500,
        nomAction: 50,
        nomAPI: 80,
        nomTable: 50,
    },
    apiBaliseRetour: {
        libelleBaliseRetour: 500,
    },
    apiParametre: {
        libelleParametre: 50,
        nomParametre: 500,
        valeurParDefaut: 100,
    },
    categorieIntervenantEXTPersonne: {
        categorieIntervenantEXTPersonne: 50,
    },
    champMetier: {
        description: 500,
        exemple: 100,
        libelleV2: 100,
        libelleV4: 100,
        nomChamp: 100,
        nomTable: 100,
        prefix: 100,
        requeteSQL: 1000,
        stringFormat: 500,
        type: 100,
    },
    compte: {
        adresse: 255,
        complementAdresse: 255,
        cp: 5,
        email: 100,
        fax: 50,
        mobile: 50,
        nom: 50,
        prenom: 50,
        tel: 50,
        ville: 50
    },
    contact: {
        adresse: 255,
        complementAdresse: 255,
        creerPar: 50,
        dateNaissanceEnfant: 4,
        email: 100,
        lieuNaissance: 50,
        mi_AutresSourcesRevenus: null,
        mi_ConservationsElements: null,
        mi_EvolutionsPossiblesTravail: null,
        mi_Hobbies: null,
        mi_LieuLogementActuel: 250,
        mi_LieuTravail: null,
        mi_LoyerLogementActuel: 250,
        mi_ManquesLogementActuel: null,
        mi_ModeDeVie: null,
        mi_SouhaitFutureMaison: null,
        nationalite: 50,
        nom: 50,
        nomEmployeur: 50,
        nomJeuneFille: 50,
        pays: 50,
        prenom: 50,
        profession: 50,
        proprietaireEnCours: 50,
        tel1: 50,
        tel2: 50,
    },
    demande: {
        demande: null,
        reponse: null,
    },
    document: {
        nom: 255,
    },
    echeancier: {
        nomEcheancier: 50,
    },
    intervenantEXTPersonne: {
        email: 50,
        fonction: 50,
        nom: 50,
        prenom: 50,
        portable: 50,
        remarque: 255,
        tel: 50,
    },
    intervenantEXTSociete: {
        adresse: 255,
        email: 50,
        fax: 50,
        formeJuridique: 50,
        nom: 50,
        pays: 50,
        siren: 9,
        sirenEtablissement: 5,
        sirenVille: 25,
        tel: 50,
    },
    lot: {
        batiment: 10,
        numCoPro: 50,
        numero: 50,
    },
    lotCommercial: {
        numero: 50
    },
    message: {
        texte: null,
    },
    news: {
        contenu: null,
        titre: 50,
    },
    notificationPush: {
        description: 200,
        nomNotificationPush: 200,
    },
    operation: {
        adresse: 255,
        adresseBulleVente: 50,
        complementAdresse: 255,
        complementAdresseBulleVente: 50,
        cpBulleVente: 5,
        descriptifCommercial: 1000,
        faiblesses: 255,
        flashCommercial: 255,
        forces: 255,
        horaireOuvertureBulleVente: 1000,
        nomCommercial: 255,
        nomOperation: 255,
        numeroCompte: 50,
        syndicCoPro: 50,
        telBulleVente: 50,
        texteContratDispositionsDiverses: null,
        texteContratListesAnnexes: null,
        texteContratProjetConstruction: null,
        villeBulleVente: 50,
    },
    programme: {
        adresse: 255,
        complementAdresse: 255,
        programme: 100,
        programmeCommercial: 100,
        ville: 50,
    },
    reglement: {
        banque: 50,
        intitule: 255,
        reference: 255,
    },
    relance: {
        relance: null,
    },
    reservation: {
        adresseNotaireClient: 50,
        complementAdresseNotaireClient: 50,
        conditionsParticulieres: 255,
        cpNotaireClient: 5,
        dgNomBanque_Cheque: 100,
        dgNumChequeClient_Cheque: 50,
        dgNumCompte_Cheque: 50,
        emailNotaireClient: 50,
        nomNotaireClient: 50,
        portableNotaireClient: 50,
        prenomNotaireClient: 50,
        remarques: null,
        suiviNotaireCommentaire: 500,
        telNotaireClient: 50,
        villeNotaireClient: 50,
    },
    societe: {
        adresse: 50,
        cp: 5,
        endpointPush: null,
        fax: 50,
        loginPush: null,
        motDePassePush: null,
        nom: 50,
        pays: 50,
        raisonSociale: 50,
        siren: 9,
        sirenEtablissement: 5,
        sirenVille: 50,
        tel: 50,
        urlPush: null,
        ville: 50,
    },
    souhait: {
        mi_Annexes: null,
        mi_AttenteConstructeur: null,
        mi_BanquesRencontrees: 250,
        mi_ButProjetConstruction: null,
        mi_Chauffage: null,
        mi_CommentairesApresRdv1: null,
        mi_CommuneNonSouhaitee: 250,
        mi_Concessions: null,
        mi_ConfreresRencontres: null,
        mi_ConnaissanceEntourageConstruction: null,
        mi_ConnaissanceGroupe: null,
        mi_ConseillerTechnique: null,
        mi_DemarchesEffectueesProjet: null,
        mi_ElementsImportantsProjet: null,
        mi_EmplacementIdeal: 250,
        mi_FinancementEnvisage: null,
        mi_LieuNounouEnfants: 250,
        mi_LieuxTerrainsVisites: null,
        mi_Menuiseries: null,
        mi_PersonneAidanteFinancement: 250,
        mi_PersonneTerrainsVisites: 250,
        mi_PointsImportantsTerrain: null,
        mi_ProfilMme: 250,
        mi_ProfilMr: 250,
        mi_Sanitaires: null,
        mi_TerrainEnvisage: null,
        mi_TerrainIdealEtEmplacement: null,
        mi_TravauxReserves: null,
        mi_TypeArchitecture: null,
        mi_Volets: null,
        rechercheRemarque: null,
    },
    tache: {
        demandeur: 250,
        titre: 250,
    },
    ticket: {
        description: null,
        descriptionTechnique: 1024,
    },
    ticketHistorique: {
        description: 3072,
    },
    tma: {
        designation: 50,
    },
    trancheTravaux: {
        nomMairie: 50,
        numPC: 50,
        trancheTravaux: 100,
    },
    operisNomenclature: {
        societe: 5,
        entite: 5,
        projet: 15,
        activite: 15,
    }
};
